module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modul-form"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Modul Pembelajaran',
          to: {
            path: '/modul-pembelajaran'
          },
          exact: true,
        },
        {
          text: !_vm.$route.query.id ?
            'Tambah Modul Belajar' :
            'Ubah Modul Belajar',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Modul Baru" : "Ubah Modul") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-7",
    attrs: {
      "plain": ""
    }
  }, [(_vm.isFetchingDetail) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "article, list-item-two-line@4, actions"
    }
  }) : (_vm.detailError) ? _c('div', {
    staticClass: "py-10 text-center"
  }, [_c('v-icon', {
    attrs: {
      "size": "48",
      "color": "grey lighten-1"
    }
  }, [_vm._v("\n                mdi-alert-circle-outline\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold mt-3 black--text"
  }, [_vm._v("\n                Gagal memuat data modul\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("Periksa koneksi Anda, lalu coba lagi.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 mr-2",
    attrs: {
      "depressed": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/modul-pembelajaran')
      }
    }
  }, [_vm._v("\n                Kembali\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 blew white--text",
    attrs: {
      "depressed": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.fetchDetail()
      }
    }
  }, [_vm._v("\n                Coba Lagi\n            ")])], 1) : _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1 mb-4"
  }, [_vm._v("\n                Kolom bertanda "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")]), _vm._v(" wajib diisi.\n            ")]), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Nama Modul "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Nama Modul Belajar",
      "outlined": "",
      "rules": [
        function (v) { return !!(v && v.trim()) ||
        'Nama Modul wajib diisi'; } ]
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Mata Pelajaran "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "items": _vm.mapelList,
      "outlined": "",
      "item-text": "nama",
      "return-object": "",
      "placeholder": "Ketik mata pelajaran",
      "no-data-text": "Data mata pelajaran tidak tersedia",
      "chips": "",
      "rules": [
        function (v) { return !!v || 'Mata Pelajaran wajib dipilih'; } ]
    },
    on: {
      "change": _vm.getItembanks
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          staticClass: "pa-0 ma-0"
        }, [_c('v-list-item-avatar', {
          staticClass: "my-0 ml-0 mr-3"
        }, [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])]
      }
    }]),
    model: {
      value: (_vm.mapel),
      callback: function($$v) {
        _vm.mapel = $$v
      },
      expression: "mapel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Topik "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('app-autocomplete', {
    attrs: {
      "placeholder": "Cari Bab / (Sub) Sub Bab",
      "data": _vm.topics,
      "rules": [
        function (v) { return !!(v && v.id) || 'Topik wajib dipilih'; } ],
      "value": _vm.topic,
      "topic": _vm.subSubBabId ?
        _vm.subSubBabId :
        _vm.subBabId ?
        _vm.subBabId :
        _vm.babId
    },
    on: {
      "selected": function($event) {
        return _vm.assignTopic($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Jenjang "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": [function (v) { return !!v || 'Jenjang wajib dipilih'; }]
    },
    on: {
      "change": function($event) {
        return _vm.resetKelas()
      }
    },
    model: {
      value: (_vm.form.jenjang),
      callback: function($$v) {
        _vm.$set(_vm.form, "jenjang", $$v)
      },
      expression: "form.jenjang"
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('v-radio', {
      key: item,
      staticClass: "jenjang-selection",
      attrs: {
        "label": item,
        "value": item,
        "active-class": "act-radio-btn"
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.form.jenjang) ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Kelas "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-input', {
    attrs: {
      "value": _vm.kelas,
      "rules": [
        function () { return _vm.selectedGrades.length > 0 ||
        'Kelas wajib dipilih minimal satu'; } ]
    }
  }, [_c('div', {
    staticClass: "d-inline"
  }, _vm._l((_vm.validGrades), function(grade) {
    return _c('v-checkbox', {
      key: grade,
      staticClass: "pa-2 ma-0 d-inline-flex",
      attrs: {
        "label": String(grade),
        "value": grade,
        "hide-details": ""
      },
      model: {
        value: (_vm.kelas),
        callback: function($$v) {
          _vm.kelas = $$v
        },
        expression: "kelas"
      }
    })
  }), 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Status User "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": [function (v) { return !!v || 'Status User wajib dipilih'; }]
    },
    model: {
      value: (_vm.form.status_user),
      callback: function($$v) {
        _vm.$set(_vm.form, "status_user", $$v)
      },
      expression: "form.status_user"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_free",
      "label": "FREE",
      "value": "FREE",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_type_premium",
      "label": "PREMIUM",
      "value": "PREMIUM",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Kurikulum "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": [function (v) { return !!v || 'Kurikulum wajib dipilih'; }]
    },
    model: {
      value: (_vm.form.kurikulum),
      callback: function($$v) {
        _vm.$set(_vm.form, "kurikulum", $$v)
      },
      expression: "form.kurikulum"
    }
  }, [_c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "KM",
      "value": "KM",
      "outlined": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13",
      "value": "K13",
      "outlined": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13 IPA",
      "value": "saintek",
      "outlined": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "K13 IPS",
      "value": "soshum",
      "outlined": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "label": "TKA",
      "value": "TKA",
      "outlined": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Semester "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": [function (v) { return !!v || 'Semester wajib dipilih'; }]
    },
    model: {
      value: (_vm.form.semester),
      callback: function($$v) {
        _vm.$set(_vm.form, "semester", $$v)
      },
      expression: "form.semester"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Ganjil",
      "value": "GANJIL",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Genap",
      "value": "GENAP",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "px-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Upload PDF "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-input', {
    attrs: {
      "value": _vm.presentationPath,
      "rules": [function (v) { return !!v || 'File PDF wajib diunggah'; }]
    }
  }, [_c('v-card', {
    staticClass: "flex-grow-1 pdf-card",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center pa-3"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "color": _vm.presentationPath ? 'red' : 'grey'
    }
  }, [_vm._v("\n                                    mdi-file-pdf-box\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "text-truncate flex-grow-1"
  }, [_vm._v("\n                                    " + _vm._s(_vm.pdfFile ?
    _vm.pdfFile.name :
    _vm.presentationPath ?
    "File PDF tersimpan" :
    "Belum ada file dipilih (format .pdf)") + "\n                                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blew--text font-weight-bold ml-3",
    attrs: {
      "color": "#e8f5fa",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader2.click()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-upload")]), _vm._v("\n                                    " + _vm._s(_vm.presentationPath ?
    "Ganti File" :
    "Upload File") + "\n                                ")], 1), _vm._v(" "), _c('input', {
    ref: "uploader2",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), (_vm.presentationPath) ? [_c('v-divider'), _vm._v(" "), _c('embed', {
    staticClass: "pdf-preview",
    attrs: {
      "src": _vm.presentationPath,
      "type": "application/pdf"
    }
  })] : _vm._e()], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Password PDF\n                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Password PDF",
      "outlined": ""
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        Status "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": "",
      "rules": [function (v) { return !!v || 'Status wajib dipilih'; }]
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Draft",
      "value": "DRAFT",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Review",
      "value": "REVIEW",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Publikasi",
      "value": "PUBLISHED",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                        User Group "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _vm._l((_vm.form.user_group), function(usgr, i) {
    return _c('v-autocomplete', {
      key: i,
      attrs: {
        "items": _vm.user_groups,
        "item-text": "user_group_name",
        "item-value": "id",
        "placeholder": "-- Pilih user group --",
        "loading": _vm.isFetchingUserGroups,
        "no-data-text": "Data user group tidak tersedia",
        "outlined": "",
        "rules": [function (v) { return !!v || 'User Group wajib dipilih'; }]
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function() {
          return [(
            i === _vm.form.user_group.length - 1 &&
            _vm.form.user_group.length != 1
          ) ? _c('v-btn', {
            staticClass: "font-weight-bold dark--text",
            attrs: {
              "id": "user-remove-scope-btn",
              "dark": "",
              "large": "",
              "depressed": "",
              "color": "white"
            },
            on: {
              "click": function($event) {
                _vm.queryId
                  ?
                  null :
                  _vm.form.user_group.splice(i, 1)
              }
            }
          }, [_vm._v("\n                                Hapus\n                            ")]) : _vm._e()]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.form.user_group[i]),
        callback: function($$v) {
          _vm.$set(_vm.form.user_group, i, $$v)
        },
        expression: "form.user_group[i]"
      }
    })
  })], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-5 mt-8",
    attrs: {
      "id": "user-add-scope-btn",
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        return _vm.form.user_group.push('')
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("\n                    mdi-plus-circle\n                ")]), _vm._v("\n                Tambah User Group Baru\n            ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold blew--text mb-1",
    attrs: {
      "block": "",
      "depressed": "",
      "color": "#e8f5fa"
    },
    on: {
      "click": function($event) {
        return _vm.openOrderDialog()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    staticStyle: {
      "font-size": "22px !important"
    }
  }, [_vm._v("\n                    mdi-sort-bool-ascending-variant\n                ")]), _vm._v("\n                Atur Urutan Modul\n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text text--darken-1 mb-5"
  }, [_vm._v("\n                " + _vm._s(_vm.form.module_order ?
    "Nomor urut: " + _vm.form.module_order :
    "Nomor urut otomatis di urutan terakhir pada bab dan kelas yang sama.") + "\n            ")]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "primary",
      "depressed": "",
      "loading": _vm.isLoading,
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("\n                    Simpan\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.onSubmit();
        _vm.dialogConfirm.open = false;
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px"
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', [_vm._v("\n                    Urutan Modul Belajar\n                    "), _c('span', {
          staticClass: "ml-2 font-weight-regular"
        }, [_vm._v("\n                        (Bab " + _vm._s(_vm.currentBabName) + "\n                        "), _c('span', {
          staticClass: "blew--text"
        }, [_vm._v("Kelas " + _vm._s(_vm.orderGrade))]), _vm._v(")\n                    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loadingSequence) ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "primary",
            "size": 30
          }
        }) : _vm._e(), _vm._v(" "), (_vm.updatedSequence && !_vm.loadingSequence) ? _c('v-icon', {
          staticStyle: {
            "font-size": "32px"
          },
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("mdi-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-subtitle', [_c('div', [_vm._v("\n                        Atur urutan dengan drag list modul. Urutan berlaku\n                        untuk modul dalam bab dan kelas yang sama.\n                    ")]), _vm._v(" "), _c('div', {
          staticClass: "mt-5 mb-5"
        }, _vm._l((_vm.selectedGrades), function(grade) {
          return _c('v-btn', {
            key: grade,
            staticClass: "mr-2",
            class: _vm.orderGrade === grade ?
              'blew--text' :
              'grey--text',
            attrs: {
              "color": _vm.orderGrade === grade ? '#e8f5fa' : '#f3f5f7',
              "depressed": "",
              "rounded": ""
            },
            on: {
              "click": function($event) {
                _vm.orderGrade = grade;
                _vm.loadOrderList();
              }
            }
          }, [_vm._v("\n                            Kelas " + _vm._s(grade) + "\n                        ")])
        }), 1)]), _vm._v(" "), _c('v-card-text', {
          attrs: {
            "width": "100%"
          }
        }, [_c('div', {
          staticClass: "mt-3 mb-5 pl-4 font-weight-bold"
        }, [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "2"
          }
        }, [_vm._v("Nomor Urut")]), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "8"
          }
        }, [_vm._v("Nama Modul")])], 1)], 1), _vm._v(" "), (_vm.isFetchingModuls) ? _c('div', {
          staticClass: "mt-8"
        }, [_c('v-skeleton-loader', {
          attrs: {
            "type": "card"
          }
        })], 1) : _c('div', [_c('draggable', {
          staticClass: "list-group",
          attrs: {
            "list": _vm.modul2,
            "disabled": _vm.loadingSequence,
            "ghost-class": "ghost"
          },
          on: {
            "end": _vm.finishDragged
          }
        }, [_vm._l((_vm.modul2), function(modul, index) {
          return _c('div', {
            key: modul.id,
            staticClass: "list-group-item pa-6 draggable",
            class: modul.current ? 'selected' : ''
          }, [_c('v-row', [_c('v-col', {
            attrs: {
              "cols": "2",
              "md": "2"
            }
          }, [_c('v-btn', {
            staticClass: "font-weight-bold",
            class: modul.current ?
              'teal--text text--darken-1' :
              '',
            staticStyle: {
              "font-size": "14px"
            },
            attrs: {
              "color": modul.current ?
                'white' :
                'blew',
              "rounded": "",
              "fab": "",
              "x-small": "",
              "dark": !modul.current,
              "depressed": ""
            }
          }, [_vm._v("\n                                            " + _vm._s(index + 1) + "\n                                        ")])], 1), _vm._v(" "), _c('v-col', {
            staticClass: "pt-1",
            class: {
              'font-weight-bold': modul.current,
            },
            attrs: {
              "cols": "8",
              "md": "8"
            }
          }, [_vm._v("\n                                        " + _vm._s(modul.name) + "\n                                    ")])], 1)], 1)
        }), _vm._v(" "), (!_vm.modul2.length) ? _c('div', {
          staticClass: "text-center"
        }, [_vm._v("\n                                Modul tidak tersedia\n                            ")]) : _vm._e()], 2)], 1)]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14463180","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/modul_belajar_2022/components/Form.vue
// module id = 1885
// module chunks = 1